<!--
  class="text-container"
-->
<div
  [ngClass]="classStyle ? classStyle : 'text-container'"
  [ngStyle]="{
    'white-space': isHovered ? 'normal' : 'nowrap',
    'text-overflow': isHovered ? 'clip' : 'ellipsis',
    'word-wrap': 'break-word',
    'word-break': 'break-word'
  }"
  (mouseover)="onMouseOver()"
  (mouseleave)="onMouseLeave()">
  {{ displayText }}
</div>
